import { useState } from "react";
import { Button, Form, Input, Radio } from "antd";
import { SendOutlined } from "@ant-design/icons";
import { t } from "i18next";
import ApiService from "../../core/service/ApiService";
import NotificationService from "../../core/service/NotificationService";
import UserSelectList from "../user/UserSelectList";

export default function SendTestSmsModal({ onSuccess }) {
    const [form] = Form.useForm();
    const [mode, setMode] = useState('user');
    const [loading, setLoading] = useState(false);

    const onFinish = async (values) => {
        setLoading(true);
        try {
            const res = await ApiService.SmsLog.SendTestSms({
                userId: mode === 'user' ? values.userId : null,
                phoneNumber: mode === 'phone' ? values.phoneNumber : null,
                message: values.message,
            });
            if (res.success) {
                if (res.data) {
                    NotificationService.success(t('SMS sent.'));
                } else {
                    NotificationService.error(t('SMS could not be sent.'), t('See the SMS log row for the error detail.'));
                }
                onSuccess && onSuccess();
            }
        } finally {
            setLoading(false);
        }
    }

    return (
        <Form form={form} layout="vertical" onFinish={onFinish}>
            <Form.Item label={t('Target')}>
                <Radio.Group value={mode} onChange={(e) => setMode(e.target.value)}>
                    <Radio value="user">{t('User')}</Radio>
                    <Radio value="phone">{t('Phone')}</Radio>
                </Radio.Group>
            </Form.Item>

            {mode === 'user' ? (
                <Form.Item
                    name="userId"
                    label={t('User')}
                    rules={[{ required: true, message: t('Please select a user') }]}
                >
                    <UserSelectList style={{ width: '100%' }} size="middle" showSelf={true} />
                </Form.Item>
            ) : (
                <Form.Item
                    name="phoneNumber"
                    label={t('Phone')}
                    rules={[{ required: true, message: t('Please enter phone number') }]}
                >
                    <Input placeholder="905xxxxxxxxx" />
                </Form.Item>
            )}

            <Form.Item
                name="message"
                label={t('Message')}
                rules={[{ required: true, message: t('Please enter message') }]}
            >
                <Input.TextArea rows={4} maxLength={500} showCount />
            </Form.Item>

            <Form.Item style={{ marginBottom: 0, textAlign: 'right' }}>
                <Button type="primary" htmlType="submit" icon={<SendOutlined />} loading={loading}>
                    {t('Send')}
                </Button>
            </Form.Item>
        </Form>
    )
}
